<script>
  import { descending } from 'd3-array';
  import RenderedMap from './RenderedMap.svelte';
  import { getCAColor, NEUTRAL, TIE } from '../colors.js';
  import { formatPercent } from '../utils/format.js';

  /**
   * @type {GeoJSON.FeatureCollection}
   */
  export let geography;

  /**
   * @type {GeoJSON.FeatureCollection}
   */
  export let roads;

  /**
   * @type {GeoJSON.FeatureCollection}
   */
  export let cities;

  /**
   * @type {import('../types.d').ReadableCandidateLookup}
   */
  export let candidates;

  /**
   * @type {import('../types.d').ReadableSubunitLookup}
   */
  export let subunits;

  export let includeParty = true;

  $: getFillStyle = (/** @type {GeoJSON.Feature} */ feature) => {
    const code = /** @type {string} */ (feature.properties.code);
    const subunit = $subunits.get(code);

    /** @type {string} */
    let color;

    if (!subunit) {
      color = NEUTRAL;
    } else if (
      subunit.total_votes <= 0 ||
      subunit.precincts_reporting_percent < 25
    ) {
      color = NEUTRAL;
    } else {
      const results = subunit.results
        .slice()
        .sort((a, b) => descending(a[1], b[1]));
      const [leaderApId, leaderVotes] = results[0];
      const [, secondVotes] = results[1];
      if (leaderVotes === secondVotes) {
        color = TIE;
      } else {
        const candidate =
          /** @type {import('../types.d').CandidateInterface}*/ (
            $candidates.get(leaderApId)
          );

        const partyColor = getCAColor(candidate.party);
        // console.log(candidate, partyColor)
        color = partyColor;
      }
    }
    
    return color;
  };

  $: findRaceData = (/** @type {GeoJSON.Feature} */ feature) => {
    if (feature && feature.properties) {
      const subunit = $subunits.get(feature.properties.code);

      if (subunit) {
        const results = subunit.results;

        const cands = results
          .filter(([_, votes]) => votes > 0)
          .slice(0, 3)
          .map(([ap_id, votes]) => {
            const candidate =
              /** @type {import('../types.d').CandidateInterface}*/ (
                $candidates.get(ap_id)
              );
            return /** @type {import('../types.d').TooltipCandidateInterface} */ ({
              ap_id,
              name: candidate.family_name,
              party: candidate.party,
              votes,
              votePercent: formatPercent(votes, subunit.total_votes),
            });
          });

        return {
          name: subunit.name,
          candidates: cands,
          totalVotes: subunit.total_votes,
          precinctsTotal: subunit.precincts_total,
          precinctsReporting: subunit.precincts_reporting,
          eevp: subunit.precincts_reporting_percent,
          includeParty,
        };
      }
    } else {
      return undefined;
    }
  };
</script>

<RenderedMap {getFillStyle} {findRaceData} {geography} {roads} {cities} />
